import React, { useCallback, useMemo } from 'react';
import { CustomScalarSpreadsheet } from 'components';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import { getArrayValue } from 'utilities';

const ValuesPerShareTable = ({ onChange, valuesPerShareSheet, workbook, format, formatDispatch }: any) => {
  const perShareFormat = useMemo(
    () => (format ? { ...format, currency: { ...format.currency, units: '' } } : format),
    [format]
  );

  const perShareFormatDispatch = useCallback(
    (action: any) => {
      if (action?.currency?.units !== undefined) {
        const { units: _stripped, ...currencyWithoutUnits } = action.currency;
        formatDispatch?.({ ...action, currency: currencyWithoutUnits });
      } else {
        formatDispatch?.(action);
      }
    },
    [formatDispatch]
  );

  const valuesPerShareSheetProps = useMemo(() => {
    if (valuesPerShareSheet) {
      return {
        ...valuesPerShareSheet,
        data: getArrayValue(valuesPerShareSheet?.data),
        format: perShareFormat,
        formatDispatch: perShareFormatDispatch,
        onChange,
        sheet: valuesPerShareSheet,
        workbook,
      } as unknown as typeof ScalarSpreadsheet;
    }

    return null;
  }, [perShareFormat, perShareFormatDispatch, onChange, valuesPerShareSheet, workbook]);

  return (
    <>
      {valuesPerShareSheetProps && valuesPerShareSheet && (
        <CustomScalarSpreadsheet {...valuesPerShareSheetProps} isLoading={false} />
      )}
    </>
  );
};
export default ValuesPerShareTable;
